import { userAuthStore } from "../infrastructure/store/userAuthStore";

export const resetUserAuthSession = {
  async execute(): Promise<void> {
    await userAuthStore().reset();
  },
};
